import React, { useEffect, useCallback, useState} from 'react';
import {JAKI_PARAMS} from 'constants/pullable-types.js';
import PullablePart from "components/pulled/PullablePart.js";
import TrackRules from './TrackRules.js';
import TrackThumbnail from "components/TrackThumbnail.js";
import CheckboxParameter from "components/effects/CheckboxParameter.js";
import DrumCircle from './DrumCircle.js';
import ParameterBox from 'components/instruments/ParameterBox.js';
import {TRACK} from './constants.js';
import {connect} from 'react-redux';

const DrumRouter = ({isDraggable, effect, setChosen, chosen, sequencerEngine=effect.track.sequencerEngine}) => { 
    let tracks = [1, 2, 3, 4, 5, 6];

    
    if (!effect.jakiParams) {
        return '';
    }
    return (
        <PullablePart
          isDraggable={isDraggable}
          effect={effect}
          skipDiv={true}
          instrument={effect.jakiParams}
          type={JAKI_PARAMS}
          className="drum-router">
          <div className="track-col labeler">
            <div className="empty-thumb"/>
            <div className="track-btn"/>
            <div className="track-pattern">
              1
            </div>
            <div className="track-shift">
              Rules
            </div>
            <div className="track-shift">
              Shift
            </div>
            <div className="track-shift">
              Truncate
            </div>
            <div className="track-shift">
              Swing
            </div>
            <div className="track-shift">
              Offset
            </div>
            <div className="track-shift">
              Tempo
            </div>
            <div className="track-shift">
              Triplet
            </div>
            <div className="track-shift">
              Scale
            </div>
          </div>
        {tracks.map(
            track =>
                <div className="track-col">
                  {sequencerEngine.tracks[track-1] ?
                   <TrackThumbnail
                     onClickThumbnail={(e) => {
                         e.stopPropagation();
                         if (setChosen) {
                             setChosen({type: TRACK, track});
                         }
                     }}
                     track={sequencerEngine.tracks[track-1]}/> : <div className="empty-thumb"/>}
                  <div
                    onClick={(e) => {
                        e.stopPropagation();
                        if (setChosen) {
                            setChosen({type: TRACK, track});
                        }
                    }}
                    className={chosen && chosen.track === track ?
                               "track-btn selected" : "track-btn"}>
                    {track}
                  </div>
                  <DrumCircle number={track} effect={effect.jakiParams}/>
                  <TrackRules effect={effect} parameter={effect.jakiParams["rule" + track + "Parameter"]}/>
                  <ParameterBox width={34} needsRound={true} parameter={effect.jakiParams["shift" + track + "Parameter"]} min={0} max={16}/>
                  <ParameterBox width={34} needsRound={true} parameter={effect.jakiParams["truncate" + track + "Parameter"]} min={0} max={8}/>
                  <ParameterBox width={34} needsRound={true} parameter={effect.jakiParams["swing" + track + "Parameter"]} min={50} max={100}/>
                  <ParameterBox width={34} needsRound={true} parameter={effect.jakiParams["offset" + track + "Parameter"]} min={0} max={100}/>
                  <ParameterBox
                    width={34}
                    needsRound={true}
                    parameter={effect.jakiParams["tempo" + track + "Parameter"]}
                    min={1}
                    max={5}/>
                  <CheckboxParameter parameter={effect.jakiParams["triplet" + track + "Parameter"]}/>
                  <CheckboxParameter parameter={effect.jakiParams["scale" + track + "Parameter"]}/>
                </div>
        )}
        </PullablePart>
    );
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DrumRouter);
